<template>
  <div class="login">
    <div class="alert_logIn" :style="{backgroundImage: 'url('+ `${pagebase}/static/img/login/login_back.png` +')'}">
      <div>
        <div class="get_phone">
          <!-- <div>+86</div> -->
          <DiallingCodeSelection v-model="diallingCode" />
          <input type="number" placeholder="请输入手机号" class="phone" v-model="phone" @input="phoneInput">
        </div>
        <div class="get_verification_code">
          <input type="number" placeholder="请输入验证码" class="verification_code" v-model="smsCode">
          <div class="getCode" :class="{checkValid: codeEnabled}" @click="getSmsCode">{{buttonMsg}}</div>
        </div>

        <div class="bottomArea">
          <div class="bottom">
            <p class="checkboxBtn" v-show="checkboxValue == 0" @click="checkboxValue = 1"></p>
            <img :src="`${pagebase}/static/img/login/icon_1.png`" alt="" v-show="checkboxValue == 1" @click="checkboxValue = 0">
            <div>
              <p>登录即代表您同意<span class="link" @click="linkOutTo(pagebase + '/h5/agreement/elecomPrivacyPolicy.html')">《电巢隐私政策》</span>和<span class="link" @click="linkOutTo(pagebase + '/h5/agreement/elecomServeAgreement.html')">《电巢服务协议》</span></p>
              <p>未注册的用户我们将会自动为您创建账户</p>
            </div>
          </div>

          <div class="login_btn" :class="{loginCheckValid: loginEnabled}" @click="handleClick">
            <p>登录</p>
          </div>
        </div>
      </div>
      
      <div v-show="hintShow" class="hintMod">
        <p>{{hintCon}}</p>
      </div>
    </div>
  </div>
</template>

<script>
  import DiallingCodeSelection from './DiallingCodeSelection'
  import utils from '@/utils/utils'
  import Cookies from 'js-cookie'
  import { cookieDomain, pagebase, pagehost } from '@/utils/http'

  export default {
    components: {
      DiallingCodeSelection: DiallingCodeSelection
    },
    data() {
      return {
        redirect: this.$route.query.redirect || '',
        phone: '',
        diallingCode: '86',
        smsCode: '',
        checkboxValue: 0,
        codeEnabled: false,
        limitTime: 60,
        buttonMsg: '获取验证码',
        hintShow: false,
        hintTime: 1,
        hintCon: '',
        from: this.$route.query.from || "",
        track_id: this.$route.query.track_id || "",
        pagebase: pagebase,
        pagehost: pagehost,
        
        urlParams: {},
        handleTimer: null,
      }
    },
    computed: {
      loginEnabled() {
        return this.codeEnabled && this.smsCode
      }
    },
    methods: {
      getSmsCode() {
        if (this.codeEnabled) {
          this.$http.get('/Registered/getPhoneSmsCode', {
            params: utils.cso({
              phone: this.phone,
              phone_head: this.diallingCode,
              type: 10,
              client: 'H5'
            })
          }).then((res) => {
            if (res.code >= 0) {
              this.buttonMsg = this.limitTime + 's后重试'
              this.timer = window.setInterval(() => {
                this.limitTime--
                this.buttonMsg = this.limitTime + 's后重试'
                if (this.limitTime < 0) {
                  window.clearInterval(this.timer)
                  this.buttonMsg = '获取验证码'
                  this.limitTime = 60
                }
              }, 1000)
            } else {
              this.setHintCon(res.msg);
            }
          })
        }
      },
      
      getUrlParams() {
        // 解析URL
        const urlObj = new URL(decodeURIComponent(this.redirect));
        // 获取哈希片段
        const hash = urlObj.hash;
        // 创建一个对象来存储参数
        const params = {};
        
        if(hash != ''){
          // 去除#号
          let cleanHash = hash.substring(1);
          const queryStringIndex = hash.indexOf("?"); // 查找问号的位置
          if (queryStringIndex >= 0) {
            cleanHash = hash.substring(queryStringIndex + 1); // 去除问号前面部分
          } else {
            cleanHash = hash; // 如果没有问号则返回原始URL
          }

          // 将参数拆分为数组
          const paramsArray = cleanHash.split('&');
          
          // 遍历参数数组并解析键值对
          paramsArray.forEach(param => {
            const [key, value] = param.split('=');
            params[key] = decodeURIComponent(value);
          });
        } else {
          if(urlObj.search != '') {
            let search = urlObj.search.substring(1);
            
            // 将参数拆分为数组
            const paramsArray = search.split('&');
            
            // 遍历参数数组并解析键值对
            paramsArray.forEach(param => {
              const [key, value] = param.split('=');
              params[key] = decodeURIComponent(value);
            });
          }
        }
        
        return params
      },
      
      login() {
        if(utils.checkPhone(this.phone) && this.smsCode){
          console.log('这里')
          let body = {
            phone_head: this.diallingCode,
            phone: this.phone,
            sms_code: this.smsCode,
            timestamp: new Date().getTime() / 1000,
            nonce: `${ Math.random().toString().slice(2) }${ this.smsCode }`,
          }
          switch (this.from) {
            case "elecexam":
            {
              let urlParams = new URLSearchParams(window.location.search);
              // 从elecexam项目微信获取的code
              body.wx_code = urlParams.get("code");
              body.wx_appid = this.$route.query.appid || "";
              break;
            }
            default:
            {
              body.activity_id = this.getUrlParams().aid ? this.getUrlParams().aid : this.getUrlParams().id;
              body.activity_channel = this.$route.query.type || '';
              break;
            }
          }
          if(this.track_id){
            body.reg_source = 10;
            body.channel_code = 'bilibili';
          }
          Object.assign(body, {
            sign: utils.loginSign(body)
          })
          if (this.checkboxValue) {
            this.$http.get('/Login/wxLogin', {
              params: body
            }).then(res => {
              console.log(res)
              if (res.code >= 0) {
                Cookies.set('uid', res.data.uid, {
                  domain: cookieDomain
                })
                Cookies.set('token', res.data.token, {
                  domain: cookieDomain
                })
                Cookies.set('username', res.data.username, {
                  domain: cookieDomain
                })
                // b站新用户就,提交b站数据
                if(res.data.is_new === 1){
                  window.bilicm.mbase.report_data()
                }
                setTimeout(()=>{
                  location.replace(`${decodeURIComponent(this.redirect)}`)
                },300)
              } else {
                this.setHintCon(res.msg)
              }
            })
          } else {
            this.setHintCon('请勾选服务协议后再登录')
          }
        }
      },
      phoneInput(e) {
        let value = e.target.value
        this.codeEnabled = utils.checkPhone(value)
      },
      linkOutTo(url) {
        window.location.href = url
      },
      
      setHintCon(e){
        window.clearInterval(this.timers)
        this.hintCon = e;
        this.hintShow = true;
        this.timers = window.setInterval(() => {
          this.hintTime--
          if (this.hintTime < 0) {
            window.clearInterval(this.timers)
            this.hintShow = false
            this.hintTime = 1
          }
        }, 1000)
      },
      
      handleClick() {
        // 清除上一次的计时器
        clearTimeout(this.handleTimer);
      
        // 设置新的计时器
        this.handleTimer = setTimeout(() => {
          // 在这里执行点击事件的逻辑
          console.log("Button clicked!");
          this.login();
        }, 500); // 设置防抖的延迟时间，单位是毫秒
      }
    }
  }
</script>

<style lang="css" scoped>
  input {
    border: none;
    outline: none;
  }

  .green {
    color: #00FF33;
  }

  .alert_logIn {
    position: fixed;
    z-index: 10;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 0 2.5rem;
    background-repeat: no-repeat;
    background-size: cover;
  }

  .login_text {
    font-size: 2.6rem;
    font-weight: bolder;
    margin-top: 3.65rem;
  }

  .login_img {
    height: 5rem;
    margin-top: 1.6rem;
  }

  .get_phone {
    box-sizing: border-box;
    margin-top: 4.4rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #FFFFFF;
    border-radius: .8rem;
    height: 5rem;
    box-shadow: .1rem .5rem .6rem rgba(143, 78, 78, 0.1);
  }

  /*.get_phone div {
    margin-left: 2rem;
    margin-right: .95rem;
    font-weight: 600;
  }*/

  .phone {
    box-sizing: border-box;
    width: 100%;
    height: 5rem;
    font-size: 1.4rem;
    border-radius: .8rem;
  }

  .get_verification_code {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 1.4rem;
    background-color: #FFFFFF;
    border-radius: .8rem;
    height: 5rem;
    box-shadow: .1rem .5rem .6rem rgba(143, 78, 78, 0.1);
  }

  .verification_code {
    box-sizing: border-box;
    width: 17rem;
    height: 4.5rem;
    border-radius: 2.25rem;
    padding: 0 1.6rem;
    font-size: 1.4rem;
  }

  .getCode {
    box-sizing: border-box;
    text-align: end;
    padding-right: 2rem;
    width: 12.1rem;
    height: 4.3rem;
    line-height: 4.5rem;
    font-size: 1.4rem;
    border-radius: 4.5rem;
    color: rgba(230, 1, 31, .5);
  }

  .checkValid {
    box-sizing: border-box;
    text-align: end;
    padding-right: 2rem;
    width: 12.1rem;
    height: 4.3rem;
    line-height: 4.5rem;
    font-size: 1.4rem;
    border-radius: 4.5rem;
    color: #E6011F;
  }

  .bottomArea {
    margin-top: 6rem;
  }

  .bottom {
    font-size: 1.2rem;
    color: #808598;
    display: flex;
    align-items: center;
  }
  
  .checkboxBtn {
    width: 1.3rem;
    height: 1.3rem;
    border: .1rem solid #808598;
    border-radius: .3rem;
  }
  
  .bottom img {
    width: 1.5rem;
    height: 1.5rem;
  }

  .bottom div {
    margin-left: 1rem;
    color: #808598;
  }

  .login_btn {
    display: flex;
    justify-content: center;
  }

  .login_btn p {
    width: 100%;
    height: 4.5rem;
    margin-top: 1rem;
    line-height: 4.5rem;
    text-align: center;
    color: #FFFFFF;
    font-size: 1.6rem;
    font-weight: bolder;
    border-radius: .8rem;
    background-color: #FFCCCC;
    box-shadow: .1rem .5rem .6rem rgba(72, 19, 19, 0.1);
  }

  .loginCheckValid p {
    width: 100%;
    height: 4.5rem;
    line-height: 4.5rem;
    text-align: center;
    color: #FFFFFF;
    font-size: 1.6rem;
    font-weight: bolder;
    background: linear-gradient(#F7443F, #EA1A14);
    box-shadow: .1rem .5rem .6rem rgba(255, 4, 70, .3);
  }

  .link {
    color: #E6011F;
  }

  .agreement {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .agreement input {
    margin-right: .5rem;
  }

  .agreement span {
    margin-top: -.1rem;
  }
  
  /* 提示 */
  .hintMod {
    box-sizing: border-box;
    position: fixed;
    bottom: 45%;
    left: 0;
    display: flex;
    justify-content: center;
    width: 100%;
  }
  
  .hintMod p {
    box-sizing: border-box;
    padding: 0 1.5rem;
    background-color: rgba(29, 32, 35, 0.5);
    font-size: 1.3rem;
    color: #FFFFFF;
    max-width: 65%;
    height: 4rem;
    border-radius: 4rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>